import React from "react";
import classes from "./UserInformation.module.css";
import LabelValue from "../LabelValue";
import { Row, Col } from "react-bootstrap";
import { user as userPlaceholder } from "../../constant";
import clsx from "clsx";
import { formatNumberWithCommas, formatPhone } from "../../helpers";
import { getUserPendingAmount ,getUserTotalAmount} from "../../lib/users";
const UserInformation = ({ user }) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <h2 className={classes.title}>User Information</h2>
      </div>
      <Row className={classes.labelValueRow}>
        <Col md={3}>
          <div className={classes.labelValueWrapper}>
            <span>
              <img
                src={user?.image ? user?.image : userPlaceholder}
                alt="user"
                className={"img-fluid"}
              />
            </span>
          </div>
        </Col>
        <Col md={3}>
          <div className={classes.labelValueWrapper}>
            <LabelValue label="Name" value={user?.userFullName} />
          </div>
          <div className={clsx(classes.labelValueWrapper, classes["mt-22"])}>
            <LabelValue label="Total Bookings" value={user?.bookings?.length} />
          </div>
        </Col>
        <Col md={3}>
          <div className={clsx(classes.labelValueWrapper)}>
            <LabelValue
              label="Phone Number"
              value={user?.cellNumber && formatPhone(user?.cellNumber)}
            />
          </div>
          <div className={clsx(classes.labelValueWrapper, classes["mt-22"])}>
            <LabelValue label="Pending Amount" value={formatNumberWithCommas(getUserPendingAmount(user?.bookings))} />
          </div>
        </Col>
        <Col md={3}>
          <div className={clsx(classes.labelValueWrapper)}>
            <LabelValue label="Email Address" value={user?.email} valueClass={classes.breakWord} />
          </div>
          <div className={clsx(classes.labelValueWrapper, classes["mt-22"])}>
            <LabelValue label="Total Amount" value={formatNumberWithCommas(getUserTotalAmount(user?.bookings)   )} />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UserInformation;
